export default __webpack_public_path__ + "static/media/App download 3.13943b46.png";